/* global Ad */
import Cookies from 'js-cookie';

/**
 * Metoda uklanja parametre koji su u konfliktu i prikazuje toast poruku.
 * Parametar "u više smještajnih jedinica" (distribution) je u konfliktu sa cijenama, devijacijom i brojem soba.
 * Ako postoji konflikt sa parametrom "u više smještajnih jedinica" prikazujemo prikladnu toast poruku ako je korisnik
 * nije već izgasio u toj sesiji.
 * Parametar "popusti" je u konfliktu sa maksimalnom cijenom.
 */
export function clearConflictingParametersUnconfigured(ToastManager, Cookies) { // eslint-disable-line no-shadow
    const distribution = document.getElementById('SearchPrivateFilterForm_p_dist').checked;
    const selectedDiscounts = document.querySelectorAll('input[name="SearchPrivateFilterForm[dc_t][]"]:checked');

    checkConflictsAndShowToast();

    if (distribution) {
        clearBedrooms();
        clearDeviation();
        clearMinimumPrice();
        clearMaximumPrice();
    }

    if (pricesInConflictWithDiscounts(selectedDiscounts)) {
        clearDiscounts();
    }

    function clearDiscounts() {
        for (let i = 0; i < selectedDiscounts.length; i += 1) {
            selectedDiscounts[i].checked = false;
        }
    }

    function clearBedrooms() {
        const bedrooms = document.getElementById('SearchPrivateFilterForm_bedrooms');
        bedrooms.value = '';
    }

    function clearDeviation() {
        const deviation = document.getElementById('SearchPrivateFilterForm_deviation');
        deviation.checked = false;

        const quickDeviation = document.getElementById('quickDeviation');
        // Element ne postoji na naslovnici, već samo na RP
        if (quickDeviation !== null) {
            quickDeviation.checked = false;
        }
    }

    function clearMinimumPrice() {
        const minPrice = document.getElementById('SearchPrivateFilterForm_prc_min');
        minPrice.value = 0;
    }

    function clearMaximumPrice() {
        const maxPrice = document.getElementById('SearchPrivateFilterForm_prc_max');
        maxPrice.value = '';
    }

    function checkConflictsAndShowToast() {
        if (bedroomsInConflictWithDistribution(distribution) || deviationInConflictWithDistribution(distribution)) {
            const message = document
                .getElementById('conflictedParametersMessages')
                .getAttribute('data-distribution-bedrooms-deviation');

            showToastMessage(message, 'js-conflictingParameter', 'distribution-bedrooms-deviation-conflict');
        }

        if (pricesInConflictWithDistribution(distribution)) {
            const message = document
                .getElementById('conflictedParametersMessages')
                .getAttribute('data-distribution-prices');

            showToastMessage(message, 'js-conflictingParameter', 'distribution-price-conflict');
        }
    }

    function showToastMessage(message, selectorClass, cookie) {
        if (!Cookies.get(cookie)) {
            ToastManager.add('info-closable', message, 99999, selectorClass);

            const toastClose = document.querySelector(`.${selectorClass} .closeToast`);
            toastClose.addEventListener('click', () => {
                Cookies.set(cookie, true, { path: '/' });
            });
        }
    }
}

function bedroomsInConflictWithDistribution(distribution) {
    const bedrooms = document.getElementById('SearchPrivateFilterForm_bedrooms').value;
    return distribution && Boolean(bedrooms);
}

function deviationInConflictWithDistribution(distribution) {
    const arrival = document.getElementById('SearchPrivateFilterForm_from').value;
    const departure = document.getElementById('SearchPrivateFilterForm_to').value;
    const deviation = document.getElementById('SearchPrivateFilterForm_deviation').checked;

    return distribution && Boolean(deviation && arrival && departure);
}

function pricesInConflictWithDistribution(distribution) {
    const minPrice = parseInt(document.getElementById('SearchPrivateFilterForm_prc_min').value, 10);
    const maxPrice = parseInt(document.getElementById('SearchPrivateFilterForm_prc_max').value, 10);

    return distribution && Boolean(minPrice || maxPrice);
}

function pricesInConflictWithDiscounts(selectedDiscounts) {
    const maxPrice = parseInt(document.getElementById('SearchPrivateFilterForm_prc_max').value, 10);
    return Boolean(selectedDiscounts.length && maxPrice);
}

export default function clearConflictingParameters() {
    return clearConflictingParametersUnconfigured(Ad.ToastManager, Cookies);
}

export function hasConflictingParameters() {
    const distribution = document.getElementById('SearchPrivateFilterForm_p_dist').checked;
    const selectedDiscounts = document.querySelectorAll('input[name="SearchPrivateFilterForm[dc_t][]"]:checked');

    return bedroomsInConflictWithDistribution(distribution)
        || deviationInConflictWithDistribution(distribution)
        || pricesInConflictWithDistribution(distribution)
        || pricesInConflictWithDiscounts(selectedDiscounts);
}
